// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ClaimQuestion = t.struct({
    choice: t.String,
    key: t.String,
    value: t.String
}, {
    name: 'ClaimQuestion',
    strict: true
});

export const getDefaultState = () => new ClaimQuestion({
    choice: '',
    key: '',
    value: ''
});

export default ClaimQuestion;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-question.js